import { useEffect, useState } from 'react'

/** Live window width, kept in sync via a resize listener. Use instead of reading
 *  `window.innerWidth` directly in render — a direct read only reflects the width
 *  at the moment of the last render, so it goes stale if the user resizes the
 *  browser without triggering some other state update first. */
export function useWindowWidth(): number {
  const [width, setWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 0))

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return width
}
